import { PluginKey } from 'prosemirror-state';
export const IMG_MAX_HEIGHT = 600; //px
export const imageRendererKey = new PluginKey('imageRenderer');
